module.exports = __webpack_public_path__ + "img/twitter-icon.029c40c2.svg";